export default __webpack_public_path__ + "static/media/017-law book.806624fd.svg";